import React, {Component, Fragment} from "react";
import {Button} from "reactstrap";
import {MakeDialog} from "../../../components/Shared/MakeDialog";
import {getData, postData} from "../../../api/doLogin";
import {toast} from "react-toastify";

export default class LMSFolderSelection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      folders: [],
      breadcrumbs: [],
      allowSave: false,
      curFolder: props.defaultFolder
    }
  }

  getFolderList(folder) {
    const self = this;
    this.setState({loading: true}, () => {
      getData(`lms/${folder}/folders`, {}, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            let curState = this.state;
            if (typeof data.data['folders'] === "object") {
              curState['folders'] = data.data.folders;
            } else {
              curState['folders'] = [];
            }
            if (typeof data.data['breadcrumbs'] === "object") {
              curState['breadcrumbs'] = data.data.breadcrumbs;
            } else {
              curState['breadcrumbs'] = [];
            }
            curState.loading = false;
            curState.curFolder = folder;
            if (folder === 0 || folder === Number(self.props.defaultFolder || "0") || folder === self.props.defaultFolder) {
              curState.allowSave = false;
            } else {
              curState.allowSave = true;
            }
            // console.log(curState)
            self.setState(curState);
          }
        }) // JSON-string from `response.json()` call
        .catch(error => {
          console.error(error)
          //self.setState({errorMsg:error,isProcessing:false});
        });
    });
  }

  save(copyOrMove) {
    if (this.props.onSave) return this.props.onSave(this.state.curFolder, this.state.breadcrumbs.filter(crumb => crumb.id !== 0).map(crumb => crumb.display).join("/"));
    const self = this;
    self.setState({loading: true}, () => {

      postData(`briefcase/${this.state.curFolder}/transfer`, {
        action: copyOrMove,
        folders: this.props.folders || [],
        files: this.props.files || [],
      }, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            // console.log(data.data);
            // EventClient.emit("NAVIGATE", `/briefcase/${this.props.folderId || 0}`);
            // self.setState({loading: false}, () => {
            self.props.onSuccess && self.props.onSuccess();
            // });
          } else {
            // console.log(data.message, data.data);
            toast.error(data.message);
            self.setState({loading: false});
          }
        }).catch((error) => {
        console.log(error);
        toast.error(`Could not ${copyOrMove} selected data`);
        self.setState({loading: false});
      });
    });
  }

  componentDidMount() {
    if (this.props.show) {
      this.getFolderList(this.props.defaultFolder || 0);
    }
  }

  tinyFolderEntry(folder_id, display) {
    return (
      <tr key={folder_id}
          style={{cursor: "pointer"}}
          onClick={() => this.getFolderList(folder_id)}
      >
        <td>
          {this.state.curFolder === 0 ?
            <i className="cil-folder"/>
            :
            <i className="cil-folder"/>
          }
        </td>
        <td>{display}</td>
      </tr>
    )
  }

  render() {
    const copyOrMove = this.props.copyOrMove || "copy";
    const files = this.props.files && this.props.files.length || 0;
    const folders = this.props.folders && this.props.folders.length || 0;
    const modeDisplay = copyOrMove === "move" ? "Move" : "Copy";

    const displayHeader = (folders, files) => {
      const counters = [];
      if (folders > 0) counters.push(`${folders} Folder(s)`);
      if (files > 0) counters.push(`${files} File(s)`);
      return `${modeDisplay} ${counters.join(" and ")}`;
    };

    return (
      <MakeDialog isOpen={this.props.show}
                  header={`${displayHeader(folders, files)}`}
                  footer={(
                    <Fragment>
                      <Button color="primary"
                              disabled={!this.state.allowSave}
                              onClick={() => this.save(copyOrMove)}>{this.props.saveButton || modeDisplay}</Button>
                      <Button color="secondary"
                              onClick={() => this.props.onCancel && this.props.onCancel()}>Close</Button>
                    </Fragment>
                  )}>
        <div>
          Selected Folder:
          <div style={{display: "inline-block", minHeight: 30, width: "100%"}}>
            <div style={{width: "70%"}}>
              {this.state.breadcrumbs && this.state.breadcrumbs.map((crumb, index) => {
                return (
                  <span key={index}>
                          <span style={{cursor: "pointer", color: "#00F"}}
                                onClick={() => this.getFolderList(crumb.id)}>
                            {`${crumb.display}`}
                          </span>
                          <span>{`${index > 0 ? " / " : " "}`}</span>
                        </span>
                )
              })}
            </div>
          </div>

          <table>
            <tbody>
            {this.state.breadcrumbs && this.state.breadcrumbs.length > 1 && this.tinyFolderEntry(this.state.breadcrumbs[this.state.breadcrumbs.length - 2].id, ".. (parent directory)")}
            {this.state.folders.map((folder, index) => this.tinyFolderEntry(folder.id, folder.display))}
            </tbody>
          </table>
          {this.state.loading && (
            <div style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              paddingTop: 100,
              backgroundColor: "#fff",
              opacity: 0.5,
              top: 0,
              left: 0
            }}>
              <div className="sk-double-bounce" style={{opacity: 1}}>
                <div className="sk-child sk-double-bounce1"></div>
                <div className="sk-child sk-double-bounce2"></div>
              </div>
            </div>
          )}
        </div>
      </MakeDialog>
    )
  }
}




// WEBPACK FOOTER //
// ./src/containers/Leads/modals/LMSFolderSelection.js